export default __webpack_public_path__ + "static/partnerColorIcon9-53ed67b662987271ae550a04f9e8d7fc.svg";